import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import SnackbarContext from '../contexts/SnackbarContext';

const ProtectedRoute = () => {
  const { currentUser } = useContext(UserContext);
  const { openSnackbar } = useContext(SnackbarContext);
  if (!currentUser) {
    openSnackbar('Você precisa estar logado para acessar essa página', 'info');
  }
    return (
      currentUser ? <Outlet /> : <Navigate to="/login" />
    )
};

export default ProtectedRoute;